import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../../../interfaces/auth";
import { getUserDndResponsibilityThunk } from "../../../../asyncThunks/manage/mapping";

const initialState: defaultState = {
  error: null,
  data: null,
  loading: false,
};

export const getUserDndResponsibilities = createSlice({
  name: "getDndResponsibilityThunk",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserDndResponsibilityThunk.pending, (state, action) => {
      state.error = null;
      state.data = null;
      state.loading = true;
    });
    builder.addCase(getUserDndResponsibilityThunk.fulfilled, (state, action) => {
      if (action?.payload?.status?.toLowerCase() === "success") {
        state.error = null;
        state.data = action.payload;
      } else {
        state.error = action?.payload;
        state.data = null;
      }
      state.loading = false;
    });
    builder.addCase(getUserDndResponsibilityThunk.rejected, (state, action) => {
      state.error = action.payload;
      state.data = null;
      state.loading = false;
    });
  },
});

export default getUserDndResponsibilities.reducer;
